import { Fieldset as BaseFieldset } from '@base-ui/react';

import { RadioDescription } from './RadioDescription';
import { RadioGroup } from './RadioGroup';
import { RadioLabel } from './RadioLabel';
import { RadioRoot } from './RadioRoot';

export const Radio = {
  Group: RadioGroup,
  GroupLegend: BaseFieldset.Legend,
  Root: RadioRoot,
  Label: RadioLabel,
  Description: RadioDescription,
};
